import script from "./TypePayment.vue?vue&type=script&lang=ts&setup=true"
export * from "./TypePayment.vue?vue&type=script&lang=ts&setup=true"

import "./TypePayment.vue?vue&type=style&index=0&id=103be4e2&lang=css"

const __exports__ = script;

export default __exports__